import { isMemberImportSimulationResponse, } from '@urbanik/api-contracts';
export class MemberImportSimulationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportSimulationApiError';
    }
}
export async function getMemberImportSimulation(baseUrl, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/simulation`, {
            headers: { Accept: 'application/json' },
            credentials: 'include',
            signal: signal ?? null,
        });
    }
    catch {
        throw new MemberImportSimulationApiError('unavailable', 'No pudimos ejecutar la simulación.');
    }
    if (response.status === 401)
        throw new MemberImportSimulationApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportSimulationApiError('forbidden', 'No tienes permiso para simular.');
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MemberImportSimulationApiError('invalid', 'La simulación devolvió datos inválidos.');
    }
    if (!response.ok || !isMemberImportSimulationResponse(payload))
        throw new MemberImportSimulationApiError('invalid', 'La simulación no es válida.');
    return payload;
}
